import React from 'react';
import {useNavigate} from 'react-router-dom';
import {ServiciosOfrecidosTipo} from './ServiciosOfrecidosTipo';

export const ContentBodyServiciosOfrecidos = () => {
	/* A hook that allows you to navigate between pages. */
	const navigate = useNavigate();

	/**
	 * It navigates to the miDashboard page.
	 */
	const goToDashBoard = () => {
		navigate('/miDashboard');
	};

	/**
	 * It navigates to the marketplace page.
	 */
	const goToMarket = () => {
		navigate('/');
	};

	return (
		<div className='contentBodyServiciosOfrecidos'>
			<div className='titleContentBodyServiciosOfrecidos'>
				<div className='centrador'>
					<h3>¿Qué tipo de cuidados estás buscando?</h3>
				</div>
			</div>
			<ServiciosOfrecidosTipo />
			<div className='buttonsInferiorContentBodyServiciosOfrecidos'>
				<div
					className='buttonAtrasServiciosOfrecidos'
					onClick={goToDashBoard}
				>
					Volver
				</div>
				<div
					className='button'
					onClick={goToMarket}
				>
					Continuar
				</div>
			</div>
		</div>
	);
};
